import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generateForm(entity: PledgeProductRead & { parameters: any }, options) {
    this.options = options;

    let avOptionInvestissementProgressifRepartition: UntypedFormGroup[] = [];

    const supportRepartitionIsin =
      entity?.parameters?.avOptionInvestissementProgressifRepartition;
    if (supportRepartitionIsin)
      _.forEach(supportRepartitionIsin, (scpi, i) =>
        avOptionInvestissementProgressifRepartition.push(
          this.formBuilder.group(this.createModel(scpi)),
        ),
      );

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avOptionInvestissementProgressifRepartition: this.formBuilder.array(
          avOptionInvestissementProgressifRepartition,
          Validators.nullValidator,
        ),
      }),
    };

    return this.formBuilder.group(formConfig, {});
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get avOptionInvestissementProgressifRepartition() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('avOptionInvestissementProgressifRepartition') as UntypedFormArray;
  }
  public createModel(item) {
    let model = {
      id: [item ? item.id : null],
      isin: [item ? item.isin || item.supportIsin : null],
      index: [item ? item.index : null],
      omniprodId: [item ? item.omniProductId || item.omniprodId : null],
      name: [item ? item.name : null],
      repartitionPercent: [item ? item.repartitionPercent : null],
      monthlyRepartition: [item ? item.monthlyRepartition : null],
      favorite: [item ? item.favorite : null],
      type: [item ? item.type : null],
      supportDescription: [
        this.options ? this.options.supportDescription : null,
      ],
      totalInvestedAmount: [this.options ? this.options.initialDeposit : null],
    };
    return model;
  }

  extract() {
    const formValue =
      this.form.value?.products?.[0]?.parameters
        ?.avOptionInvestissementProgressifRepartition;
    const avOptionInvestissementProgressifRepartition = _.filter(
      formValue,
      o => {
        return o.isin != undefined || o.isin != null;
      },
    );

    // pick only isin
    const supportRepartitionIsin = _.map(
      avOptionInvestissementProgressifRepartition,
      o => {
        return {
          isin: o.isin,
          name: o.name,
          repartitionPercent: 0,
          type: o.type,
        };
      },
    );

    const products = this.form.value?.products;
    const productsIsin = _.map(products, o => {
      return {
        ...o,
        parameters: {
          ...o.parameters,
          avOptionInvestissementProgressifRepartition: supportRepartitionIsin,
        },
      };
    });
    return productsIsin;
  }
}
